import Service from '../../services'
import { checkAndReturn, reLogin } from "../../main"

const state = {
    User: {
        user_type: 'USP'
    }
}

const getters = {

}

const actions = {
    getUser ({ commit }) {
        return Service.Auth.getUser().then(res => {
            if (res.status === 200) {
                commit('setUserInfo', res.data)
            }
            if (res.status === 401) {
                reLogin(res.data.message)
            }
            return res.data
        })
    },

    login ({ commit }, data) {
        return Service.Auth.login(data).then(res => {
            return checkAndReturn(data, res)
        })
    },
    logout ({ commit }, data) {
        return Service.Auth.logout(data).then(res => {
            return checkAndReturn(data, res)
        })
    }
}

const mutations = {

    // for local test
    setRole (state) {
        switch (state.User.user_type) {
            case 'USP':
                state.User.user_type = 'RSP'
                break

            case 'RSP':
                state.User.user_type = 'สป.อว.'
                break

            case 'สป.อว.':
                state.User.user_type = 'ผู้เชี่ยวชาญ'
                break

            case 'ผู้เชี่ยวชาญ':
                state.User.user_type = 'USP'
                break
        }
    },

    setUserInfo (state, value) {
        state.User = value
    },

    clearUserInfo (state) {
        state.User = {
            user_type: 'USP'
        }
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
